import { useEffect, useState } from "react"

import { Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import TextAreaComponent from "../../../../Components/Input/TextArea"
import Icon from "../../../../Icon"

import styles from "./AddCommentModal.module.less"

const { Text } = Typography

// CHA1-2908/CHA1-3068: "Actions: icons" -> "Add comments" -> "confirmation pop-up opens".
// `onApprove` persists the comment via PATCH …/<id>/comment/ (CHA1-3068 endpoint is live).
export const AddCommentModal = ({ open, onCancel, onApprove, initialComment, loading }) => {
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)

  const [comment, setComment] = useState("")

  useEffect(() => {
    if (open) setComment(initialComment || "")
  }, [open, initialComment])

  return (
    <Modal
      open={open}
      centered={!isMobile}
      width={442}
      title={t("Add comment")}
      footer={null}
      onCancel={onCancel}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      closeIcon={<Icon type="cross_small" />}
      getContainer={() => document.getElementById("main-layout")}
    >
      <Flex vertical gap={16}>
        <Text type="secondary">{t("Add a comment to this row for other Admins to see.")}</Text>

        <TextAreaComponent
          rows={4}
          placeholder={t("Write a comment...")}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Flex>

      <Flex gap={12} justify="end" className={styles.footer}>
        <ButtonComponent size="large" onClick={onCancel}>
          {t("Cancel")}
        </ButtonComponent>
        <ButtonComponent
          size="large"
          type="primary"
          loading={loading}
          disabled={!comment.trim()}
          onClick={() => onApprove(comment.trim())}
        >
          {t("Save")}
        </ButtonComponent>
      </Flex>
    </Modal>
  )
}

export default AddCommentModal
